import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import TeenUniqueResultBody from '../../../casinoComponents/refResultModal/TeenUniqueResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

/**
 * Unique Teenpatti "Last Result" items — reference markup: one `span.resulttie` "R" per round
 * (inside .casino-video-last-results). Click → full-page .loader-overlay while the round detail
 * loads, then the reference result modal.
 */
const ResultTeenUnique = ({
  data = [],
  gameData = {},
  gameType = 'teenunique',
}) => {
  const apiType = (gameType || 'teenunique').toLowerCase().trim();
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (response?.data?.data?.res) {
          const mappedResults = response.data.data.res.map((item) => ({
            mid: item.mid,
            win: item.win === '1' ? 'A' : item.win === '2' ? 'B' : item.win,
          }));
          setLastResults(mappedResults);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (index) => {
    setLoading(true);
    let list = lastResults;
    if (list.length === 0) {
      try {
        const response = await getLastResults(apiType);
        if (response?.data?.data?.res) {
          list = response.data.data.res.map((item) => ({ mid: item.mid, win: item.win }));
          setLastResults(list);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    }

    let mid = null;
    if (index < list.length) {
      mid = list[index]?.mid;
    } else {
      mid = gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid;
    }

    let t1 = null;
    if (mid) {
      try {
        const response = await getDetailResults(apiType, mid.toString());
        t1 = response?.data?.data?.t1 ?? response?.data?.t1 ?? null;
      } catch (error) {
        console.error('Error fetching detail results:', error);
      }
    }
    setDetailResult(t1);
    setLoading(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const count =
    lastResults.length > 0
      ? lastResults.length
      : [...(data || []), ...(gameData?.lrs || []), ...(gameData?.data?.lrs || [])].length;

  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <span key={index} className="resulttie" onClick={() => handleResultClick(index)}>
          R
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || 'Unique Teenpatti'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <TeenUniqueResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultTeenUnique;
